import useAuthenticatedResource from "../../../useAuthenticatedResource.js";
import { API_HOST_NAME } from "../constants.js";

const URL = `${API_HOST_NAME}/api/v1/auth/me`;
const OPTIONS = {};

const useCurrentUser = () => {
  return useAuthenticatedResource(URL, OPTIONS);
};

export default useCurrentUser;
